<template>
  <div :class="['layout-profile', { 'layout-profile-active': this.expanded }]">
    <button class="layout-profile-button p-link" @click="onClick">
    <!-- <button class="layout-profile-button p-link" style="cursor: auto;"> -->
      <img src="../public/invert_mbp_logo.png" alt="MBP Group Synergy System" />
      <div v-if="getProfile" class="layout-profile-userinfo">
        <span class="layout-profile-role">{{ getProfile.fullName }}</span>
        <span class="layout-profile-name">{{ getProfile.email }}</span>
      </div>
      <i class="layout-profile-icon pi pi-angle-down"></i>
    </button>

    <transition name="layout-profile-menu">
      <ul class="layout-profile-menu" v-show="expanded">
        <li role="menuitem">
          <button class="p-link" :tabIndex="expanded ? null : '-1'">
            <i class="pi pi-user"></i>
            <span>Profile</span>
          </button>
        </li>
        <!-- <li role="menuitem">
          <button class="p-link" :tabIndex="expanded ? null : '-1'">
            <i class="pi pi-cog"></i>
            <span>Settings</span>
          </button>
        </li> -->
        <!-- <li role="menuitem" :class="subMenu ? 'active-menuitem' : ''">
          <button
            class="p-link"
            @click="subMenu = !subMenu"
            :tabIndex="expanded ? null : '-1'"
          >
            <i class="pi pi-cog"></i>
            <span>Customer Settings</span>
            <i
              class="pi pi-fw pi-angle-down layout-submenu-toggler"
              :class="subMenu ? 'open' : ''"
              style="transition: transform 0.3s; float: right"
            ></i>
          </button>
          <transition name="layout-profile-setting">
            <div v-show="subMenu">
              <router-link
                v-for="(item, index) in settingItems"
                :key="index"
                :to="item.to"
                class="p-d-flex p-link link-subMenu"
                style="
                  color: #bdbdbd;
                  padding-left: 25px;
                  padding-bottom: 5px;
                  padding-top: 5px;
                "
                >{{ item.name }}</router-link
              >
            </div>
          </transition>
        </li> -->
        <!-- <li role="menuitem">
          <button class="p-link" :tabIndex="expanded ? null : '-1'">
            <i class="pi pi-envelope"></i>
            <span>Messages</span>
          </button>
        </li>
        <li role="menuitem">
          <button class="p-link" :tabIndex="expanded ? null : '-1'">
            <i class="pi pi-bell"></i>
            <span>Notifications</span>
          </button>
        </li>
        <div v-if="getProfile">
          <li v-if="getProfile" role="menuitem">
            <button @click="passwordDialog = true" class="p-link" :tabIndex="expanded ? null : '-1'">
              <i class="pi pi-fw pi-ellipsis-h"></i>
              <span>Change Password</span>
            </button>
          </li>
        </div>
        <div v-if="getProfile">
          <li v-if="getProfile" role="menuitem">
            <button @click="logout" class="p-link" :tabIndex="expanded ? null : '-1'">
              <i class="pi pi-fw pi-sign-out"></i>
              <span>Logout</span>
            </button>
          </li>
        </div>
        <div v-else>
          <li role="menuitem">
            <button @click="() => this.$router.push('/login')" class="p-link" :tabIndex="expanded ? null : '-1'">
              <i class="pi pi-fw pi-sign-in"></i>
              <span>Login</span>
            </button>
          </li>
          <li role="menuitem">
            <button @click="() => this.$router.push('/signup')" class="p-link" :tabIndex="expanded ? null : '-1'">
              <i class="pi pi-fw pi-user-plus"></i>
              <span>Signup</span>
            </button>
          </li>
        </div> -->
      </ul>
    </transition>

    <ChangePassword
      :passwordDialog="passwordDialog"
      @close="passwordDialog = false"
      @save="save"
    />
  </div>
</template>

<script>
import UserService from '@/service/UserService.js'
import ChangePassword from '@/mbp/auth/ChangePassword'

export default {
  components: {
    ChangePassword
  },
  props: {
    expanded: {
      type: Boolean,
      default: null,
    },
  },
  data: () => ({
    userService: new UserService(),
    passwordDialog: false
    // settingItems: [
    // ],
    // subMenu: false,
  }),
  computed: {
    getProfile() {
      // return JSON.parse(localStorage.getItem("profile"));
      return this.$store.getters['auth/getMyProfile']
    },
  },
  methods: {
    logout() {
      localStorage.removeItem('profile')
      localStorage.removeItem('user-token')
      localStorage.removeItem('user-refresh-token')
      setTimeout(() => {
        this.$store.dispatch('auth/setMyProfile', {})
        this.$store.dispatch('auth/setMyToken', '')
        this.$store.dispatch('auth/setMyRefreshToken', '')
        this.$router.push('/login?logout=true')
      }, 10)
    },
    save(password) {
      this.passwordDialog = false
      
      
      this.userService
        .updatePassword({
          idToken: this.$store.getters['auth/getMyToken'],
          password,
          returnSecureToken: true
        })
        .then(data => {
          

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Password updated successfully.",
            life: 5000,
          })
        })
        .catch((e) => {
          

          if (e.response.status !== 200) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating password.",
              life: 5000,
            })
          }

          if (e.response.status === 400) {
            this.$router.push('/login')
          }
        });
    },
    onClick(event) {
      this.$emit("profile-click", event);
      event.preventDefault();
    },
  },
  name: "AppInlineProfile",
};
</script>

<style lang="scss" scoped>
// .link-subMenu:hover {
//   background-color: #373737;
// }
// .open {
//   transform: rotate(-180deg);
// }

// .layout-profile-setting-enter,
// .layout-profile-setting-leave-to {
//   max-height: 0;
// }

// .layout-profile-setting-enter-to,
// .layout-profile-setting-leave {
//   max-height: 500px;
// }

// .layout-profile-setting-leave-active {
//   overflow: hidden;
//   transition: max-height 400ms cubic-bezier(0.86, 0, 0.07, 1);
// }

// .layout-profile-setting-enter-active {
//   overflow: hidden;
//   transition: max-height 1s ease-in-out;
// }
</style>
